module.exports = __webpack_public_path__ + "img/icon-ranking.dfe551c1.svg";